import React from "react";
import { Link, useNavigate } from "react-router-dom";
import "./newsandevents.css";
import Pagination from "@mui/material/Pagination";
import moment from "moment";
import templeJson from "../../config/temple.json";
import { Container, Grid } from "@mui/material";
import { useEventsData } from "./customHooks";

function HomePageNews() {
  const navigate = useNavigate();
  const {
    events,
    latestEvents,
    totalPages,
    page,
    handlePageChange,
  } = useEventsData();

  return (
    <>
      <Container maxWidth={'xl'} className=" page-header py-4 breadcrumb-bg">
        <h1 className="text-center display-6 breadcrumb-h1">Events</h1>
        <ul className="breadcrumb justify-content-center mb-0">
          <li className="breadcrumb-item">
            <Link to="/">Home</Link>
          </li>
          <li className="breadcrumb-item active">Events </li>
        </ul>
      </Container>

      <Container className="py-5">
        <Grid className="text-center mb-5">
          <h6 className="section-title text-center text-primary text-uppercase title-tl">
            Events
          </h6>
        </Grid>
        <Grid container spacing={2}>
            {/* all news section  */}
            <Grid item lg={8} md={8} className="col-lg-8 col-md-8">
              <Grid container spacing={2}>
                {events &&
                  events?.map((item) => (
                    <Grid item lg={9} md={9}>
                      <Grid
                        container
                        spacing={2}
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          navigate(`/knowmoreevents/${item.slug}`);
                        }}
                      >
                        <Grid item lg={4} md={6}>
                          <img
                            src={item.image}
                            alt="Events"
                            className="img-max"
                            style={{ width: '100%', height: 'auto', objectFit: 'cover' }}
                          />
                        </Grid>
                        <Grid item lg={8} md={6} >
                          <Grid className="events-content">
                            <Grid display={'flex'} justifyContent={'space-between'}  className="mb-4">
                              <div className="p-2 timep">
                                Date : <span>{item.full_start}</span>
                              </div>
                            </Grid>
                            <h2 className="ttl2-h2"> {item.title}</h2>
                              <p
                                style={{padding:'0 10px'}}
                                dangerouslySetInnerHTML={{
                                  __html: item.description,
                                }}
                              ></p>
                            {/* <p>
                              Please click here to
                              <a href="https://durgatemple.org/UploadFiles/sundermarch3024.pdf">
                                donate
                              </a>
                              or make check payable to {templeJson["templeName"]}
                            </p> */}
                          </Grid>
                        </Grid>
                      </Grid>
                      <div className="devider">
                        <img
                          src="./images/devider.png"
                          alt="devider"
                          className="img-max"
                        />
                      </div>
                    </Grid>
                  ))}
              </Grid>
            </Grid>
            {/* Latest news section-------------------------------------------------------------- */}
            <Grid item lg={4} md={4}>
              <h2 className="ttl2-h2">Latest Events</h2>
              <ul className="latest-news">
                {latestEvents &&
                  latestEvents.map((item) => (
                    <li>
                      <Link to={`/knowmoreevents/${item.slug}`}>
                        {moment(item?.full_start)
                          .tz("America/New_York")
                          .format("MM / DD / YY")}{" "}
                        : {item.title}
                      </Link>
                    </li>
                  ))}
              </ul>
            </Grid>
        </Grid>

        <hr />
        <Grid display={'flex'} justifyContent={'center'} alignItems={'center'} className="m-3">
          <Pagination
            count={totalPages}
            variant="outlined"
            shape="rounded"
            page={page}
            size="large"
            onChange={handlePageChange}
          />
        </Grid>
      </Container>
    </>
  );
}

export default HomePageNews;
